export default __webpack_public_path__ + "static/media/mobile-main-artist-image.7a2849ea.jpg";